import { AutogenModelOrderPayablesProfile, AutogenRowOrderPayablesProfile } from "./autogen/AutogenModelOrderPayablesProfile";

export class ModelOrderPayablesProfile extends AutogenModelOrderPayablesProfile<RowOrderPayablesProfile> {
	constructor() {
		super(RowOrderPayablesProfile);
	}
}

export class RowOrderPayablesProfile extends AutogenRowOrderPayablesProfile {
}